import React, { useEffect, useRef, useState } from "react";
import { postData } from "../../helpers/url-request";
import {
  broadcastLogout,
  clearAuthenticatedUser,
} from "../../helpers/auth-session";
import { allowLogoutNavigation } from "../../helpers/unsaved-changes";
import LogoutStatus from "./LogoutStatus";
import { onboardingDismissedSessionKey } from "../../config/onboardingTours";

const Logout = () => {
  const request = useRef(null);
  const [error, setError] = useState("");
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    let active = true;
    // Share the request across React StrictMode's effect replay.
    if (!request.current) {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 20000);
      request.current = postData(
        "/Authenticate/logout",
        {},
        controller.signal
      ).finally(() => clearTimeout(timeout));
    }
    request.current
      .then((response) => {
        if (!active) return;
        if (!response?.status) throw new Error("Logout failed");
        const result = response.data || {};
        clearAuthenticatedUser();
        sessionStorage.removeItem(onboardingDismissedSessionKey);
        allowLogoutNavigation();
        broadcastLogout();
        let incomplete = Boolean(result.microsoftSignOutIncomplete);
        try {
          incomplete =
            incomplete ||
            (!result.microsoftSignOut &&
              sessionStorage.getItem("piers.microsoft-signout") === "pending");
          sessionStorage.setItem(
            "piers.microsoft-signout",
            incomplete
              ? "incomplete"
              : result.microsoftSignOut
              ? "pending"
              : "none"
          );
        } catch {
          /* The fallback URL carries the non-sensitive failure indicator. */
        }
        const fallback = `/signin?signedOut=true${
          incomplete ? "&microsoft=incomplete" : ""
        }`;
        const target = result.microsoftSignOut
          ? result.redirectUrl || fallback
          : fallback;
        window.location.replace(incomplete ? fallback : target);
      })
      .catch(() => {
        if (active)
          setError("We could not end your PIERS session. Please retry logout.");
      });
    return () => {
      active = false;
    };
  }, [attempt]);

  const retry = () => {
    request.current = null;
    setError("");
    setAttempt((value) => value + 1);
  };
  return (
    <LogoutStatus
      title={error ? "Logout could not be completed" : "Signing you out…"}
      message={error || "Please wait while we end your session."}
    >
      {error && (
        <button className="btn btn-primary" onClick={retry}>
          Retry logout
        </button>
      )}
    </LogoutStatus>
  );
};
export default Logout;
